import React, { useCallback, useEffect, useState } from "react";
import useKeyPress from "../../hooks/key";

const digits = 6;

export default function AuthCode({
  value,
  onChange,
}: {
  value: string;
  onChange: (code: string) => void;
}) {
  const [codeValues, setCodeValues] = useState([
    value.charAt(0) ?? "",
    value.charAt(1) ?? "",
    value.charAt(2) ?? "",
    value.charAt(3) ?? "",
    value.charAt(4) ?? "",
    value.charAt(5) ?? "",
  ]);
  const [focus, setFocus] = useState(0);
  const [cooldown, setCooldown] = useState(false);
  const backspace = useKeyPress("Backspace");

  const pasteHandler = useCallback(
    (e: any) => {
      const text = e.clipboardData.getData("text");
      const tempCodeValues = [];
      for (let i = 0; i < digits; i++) {
        tempCodeValues.push(text.charAt(i));
      }
      setCodeValues(tempCodeValues);
    },
    [setCodeValues]
  );

  useEffect(() => {
    window.addEventListener("paste", pasteHandler);
    return () => {
      window.removeEventListener("paste", pasteHandler);
    };
  }, [pasteHandler]);

  useEffect(() => {
    onChange(codeValues.join(""));
  }, [codeValues, onChange]);

  useEffect(() => {
    setFocus(
      Math.min(
        codeValues.findIndex((e) => e.length === 0),
        codeValues.length - 1
      )
    );
  }, [codeValues, setCodeValues, setFocus]);

  useEffect(() => {
    if (backspace && !cooldown && focus !== 0) {
      const tempCodeValues = codeValues.slice();
      tempCodeValues[focus - 1] = "";
      setCodeValues(tempCodeValues);
    }
  }, [backspace, cooldown, focus, codeValues, setCodeValues]);

  useEffect(() => {
    if (backspace && !cooldown) {
      setCooldown(true);
      setTimeout(() => {
        setCooldown(false);
      }, 100);
    }
  }, [backspace, cooldown, setCooldown]);

  const handleChange = useCallback(
    (idx: number, newValue: string) => {
      const tempCodeValues = codeValues.slice();
      tempCodeValues[idx] = newValue;
      setCodeValues(tempCodeValues);
    },
    [codeValues, setCodeValues]
  );

  const Input = useCallback(
    ({ id, idx }: { id: string; idx: number }) => {
      return (
        <input
          id={id}
          autoComplete="off"
          maxLength={1}
          value={codeValues[idx]}
          onChange={(e) => handleChange(idx, e.target.value)}
          autoFocus={focus === idx}
          type="text"
          className="rounded-md border border-solid border-gray-300 focus:outline-none focus:ring-vendrive-500 focus:border-vendrive-500 text-sm p-2 text-center"
        ></input>
      );
    },
    [codeValues, focus, handleChange]
  );
  return (
    <div className="grid grid-cols-6 gap-3">
      <Input id="code-1" idx={0}></Input>
      <Input id="code-2" idx={1}></Input>
      <Input id="code-3" idx={2}></Input>
      <Input id="code-4" idx={3}></Input>
      <Input id="code-5" idx={4}></Input>
      <Input id="code-6" idx={5}></Input>
    </div>
  );
}
